import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import "./Navbar.css";
import logo from "../images/ignosilogo.webp";
import LeadPopup from "./LeadPopup";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  // Close menu and dropdowns on route change
  useEffect(() => {
    setIsOpen(false);
    setActiveDropdown(null);
  }, [location]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    if (isOpen) {
      setActiveDropdown(null);
    }
  };

  const toggleDropdown = (e, name) => {
    if (window.innerWidth <= 1100) {
      e.preventDefault();
      setActiveDropdown(activeDropdown === name ? null : name);
    }
  };

  const handleLinkClick = () => {
    setIsOpen(false);
    setActiveDropdown(null);
  };

  return (
    <>
      <nav className="navbarrrrr">
        <div className="nav-container">

          <div className="logo">
            <Link to="/" onClick={handleLinkClick}>
              <img src={logo} className="logo-img" alt="IGNOSI Logo" />
            </Link>
          </div>

          <div className="mobile-toggle" onClick={toggleMenu}>
            {isOpen ? <FaTimes /> : <FaBars />}
          </div>

          <div className={`nav-menu ${isOpen ? "active" : ""}`}>
            <ul className="nav-links">

              <li className={`dropdown ${activeDropdown === "solutions" ? "active" : ""}`}>
                <div
                  className="dropdown-trigger"
                  onClick={(e) => toggleDropdown(e, "solutions")}
                >
                  Solutions
                  <span className="arrow">▾</span>
                </div>

                <div className={`mega-menu ${activeDropdown === "solutions" ? "show" : ""}`}>
                  <div className="mega-content">
                    <div className="mega-column">
                      <h4>SOFTWARE SOLUTIONS</h4>
                      <Link to="/nbfc" onClick={handleLinkClick}>Ignosi BanQ | NBFC Software</Link>
                      <Link to="/mscs" onClick={handleLinkClick}>Ignosi Co-op | Multi State Software</Link>
                      <Link to="/kml" onClick={handleLinkClick}>Ignosi kml | Money lending Software</Link>
                      <Link to="/chitty" onClick={handleLinkClick}>Ignsoi Bid | Chit Fund Management Software</Link>
                      <Link to="/mfi" onClick={handleLinkClick}>Ignosi Micro |  Micro Finance Software</Link>
                      <Link to="/fpcpage" onClick={handleLinkClick}>Ignosi PC | Farmer Producer Company Software</Link>
                      <Link to="/jewel" onClick={handleLinkClick}>Ignosi Hallmark | Jewellery Software</Link>
                      <Link to="/gcalc" onClick={handleLinkClick}>Ignosi G-Calc | Gold Loan Software</Link>
                      <Link to="/nidhi" onClick={handleLinkClick}> Ignosi Alchemy | Nidhi Banking Software</Link>
                    </div>

                    <div className="mega-column">
                      <h4>MOBILE APPLICATIONS</h4>
                      <Link to="/mobileapps" onClick={handleLinkClick}>Association management software & App</Link>
                      <Link to="/mobileapps" onClick={handleLinkClick}>Payment Collection App</Link>
                      <h4>ONLINE WEB SERVICE MODULES</h4>
                      <Link to="/webservices" onClick={handleLinkClick}>Fake Gold Case Detection</Link>
                      <Link to="/webservices" onClick={handleLinkClick}>Auction Management</Link>
                      <Link to="/webservices" onClick={handleLinkClick}>Arbitration Management</Link>
                      <Link to="/webservices" onClick={handleLinkClick}>CRM Module</Link>
                      <Link to="/webservices" onClick={handleLinkClick}>Auditor Module</Link>
                      <Link to="/webservices" onClick={handleLinkClick}>Online Gold Loan Services</Link>
                      <Link to="/webservices" onClick={handleLinkClick}>Customer ID Verification</Link>
                      <Link to="/webservices" onClick={handleLinkClick}>Face Image Verification</Link>
                      <Link to="/ignosisolution" onClick={handleLinkClick}>Online Payment Collection</Link>
                    </div>
                  </div>
                </div>
              </li>

              <li className={`dropdown ${activeDropdown === "customers" ? "active" : ""}`}>
                <div
                  className="dropdown-trigger"
                  onClick={(e) => toggleDropdown(e, "customers")}
                >
                  Customers
                  <span className="arrow">▾</span>
                </div>

                <div className={`mega-menu ${activeDropdown === "customers" ? "show" : ""}`}>
                  <div className="mega-content">
                    <div className="mega-column">
                      <h4>WHO WE SERVE</h4>
                      <Link to="/#whoweserve" onClick={handleLinkClick}>Banks</Link>
                      <Link to="/#whoweserve" onClick={handleLinkClick}>Neobanks</Link>
                      <Link to="/#whoweserve" onClick={handleLinkClick}>Lenders</Link>
                      <Link to="/#whoweserve" onClick={handleLinkClick}>Fintechs</Link>
                      <Link to="/#whoweserve" onClick={handleLinkClick}>Credit Unions</Link>
                    </div>

                    <div className="mega-column">
                      <h4>USE CASES</h4>
                      <Link to="/#usecases" onClick={handleLinkClick}>Banking-as-a-Service</Link>
                      <Link to="/#usecases" onClick={handleLinkClick}>Buy Now Pay Later</Link>
                      <Link to="/#usecases" onClick={handleLinkClick}>Embedded Finance</Link>
                      <Link to="/#usecases" onClick={handleLinkClick}>Digital Lending</Link>
                      <Link to="/#usecases" onClick={handleLinkClick}>Gold & Asset Finance</Link>
                    </div>
                  </div>
                </div>
              </li>

              <li className={`dropdown partners-mega ${activeDropdown === "partners" ? "active" : ""}`}>
                <div
                  className="dropdown-trigger"
                  onClick={(e) => toggleDropdown(e, "partners")}
                >
                  Partners
                  <span className="arrow">▾</span>
                </div>
                <div className={`mega-menu ${activeDropdown === "partners" ? "show" : ""}`}>
                  <div className="mega-content">
                    <div className="mega-column">
                      <h4>TECHNOLOGY</h4>
                      <Link to="/partners" onClick={handleLinkClick}>AWS</Link>
                      <Link to="/partners" onClick={handleLinkClick}>Google Cloud</Link>
                      <Link to="/partners" onClick={handleLinkClick}>Cloudflare</Link>
                      <Link to="/partners" onClick={handleLinkClick}>Docker</Link>
                      <Link to="/partners" onClick={handleLinkClick}>Digital Ocean</Link>
                      <h4>PAYMENTS & BANKING</h4>
                      <Link to="/partners" onClick={handleLinkClick}>Razorpay</Link>
                      <Link to="/partners" onClick={handleLinkClick}>Cashfree</Link>
                      <Link to="/partners" onClick={handleLinkClick}>SIB</Link>
                      <Link to="/partners" onClick={handleLinkClick}>I Serve u</Link>
                    </div>
                  </div>
                  <div className="mega-footer">
                    <Link to="/partners" className="view-partners-btn" onClick={handleLinkClick}>
                      View Who We Partner With →
                    </Link>
                  </div>
                </div>
              </li>

              <li><Link to="/news-events" onClick={handleLinkClick}>News & Events</Link></li>
              <li><Link to="/careers" onClick={handleLinkClick}>Career</Link></li>
              <li><Link to="/about" onClick={handleLinkClick}>About us</Link></li>

            </ul>

            <div className="nav-actions">
              <button
                className="nav-btn-pill"
                onClick={() => {
                  setIsPopupOpen(true);
                  if (window.innerWidth <= 1100) toggleMenu();
                }}
              >
                Get Started
              </button>
            </div>

          </div>

        </div>
      </nav>

      <LeadPopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
    </>
  );
}

export default Navbar;
